<template>
  <v-app>
    <v-main>
      <v-container container--fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm6 md4>
            <v-card class="elevation-12">
              <a href="/">
                <img :src="logoPrimary" class="center-block logo">
              </a>
              <v-card-text>
                <b-card bg-variant="light">
                  <b-alert
                    variant="danger"
                    :show="fail"
                  >{{errorMessage}}</b-alert>
                  <p v-if="!sent"
                    class="center-block"
                  >Enter your email address and we will send you a link to reset your password.</p>
                  <div  v-bind:class="{ 'has-error': $v.email.$error }">
                    <b-form-input v-if="!sent" @input="$v.email.$touch()" v-model="email" type="text" placeholder="Enter your email"></b-form-input>
                    <span class="help-block"  v-if="!$v.email.required && $v.email.$error">Please enter your email</span>
                    <span class="help-block"  v-if="!$v.email.validEmail && $v.email.$error">Please enter a valid email</span>
                  </div>
                  <b-alert
                    variant="success"
                    :show="sent"
                  >Check your inbox for a password reset email.</b-alert>
                  <div class="input-group" style="width: 100%;">
                    <!-- <vue-recaptcha
                      ref="recaptcha"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                      size="invisible"
                      sitekey="6Ld3D7cqAAAAACgNKLhUYiHW7f4oQ5DJSWKGXOOv">
                    </vue-recaptcha> -->
                    <v-btn :disabled="$v.$invalid" v-if="!sent"
                    class="send-email"
                    block
                    color="secondary"
                    @click="sendEmailResetPassword('')"
                    type="submit"
                  >Send password reset email</v-btn>
                  </div>
                  <!-- <button class="send-email btn btn-primary g-recaptcha" 
                  data-sitekey="6Le-rYwUAAAAAOFXzU32sf0letx9LH8BnlYwWFLj"
                  data-callback="resetPassword"
                  block
                  >
                  Send password reset email
                  </button> -->
                </b-card>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import userAPIs from './views/User/userAPIs'
import { required } from 'vuelidate/lib/validators'
import { regex } from 'vuelidate/lib/validators/common'
import config from '../config'
import VueRecaptcha from 'vue-recaptcha'

const validEmail = regex('validEmail', config.regexPattern.email)

export default {
  name: 'ForgotPassword',
  components: { 'vue-recaptcha': VueRecaptcha },
  data() {
    return {
      logoPrimary: require('@/assets/Kobe Logo Blue.png'),
      email: null,
      fail: false,
      sent: false,
      errorMessage: '',
      token: ''
    }
  },
  methods: {
    validateCaptcha: function() {
      // this.$refs.recaptcha.execute()
      this.sendEmailResetPassword(this.token)
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.$refs.recaptcha.reset()
      this.sendEmailResetPassword(recaptchaToken)
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    sendEmailResetPassword(recaptchaToken) {
      userAPIs.sendEmailResetPassword(this.email, recaptchaToken).then((resp) => {
        this.sent = true
        this.errorMessage = ''
        this.fail = false
      }).catch((error) => {
        console.log(error.response.data.message)
        this.errorMessage = error.response.data.message || 'Something went wrong!'
        this.fail = true
      })
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      this.token = await this.$recaptcha('login')

      // Do stuff with the received token.
      // console.log(token)
    }
  },

  validations: {
    email: {
      required,
      validEmail
    }
  },

  created() {
    this.fail = this.$route.query.redirect
    this.recaptcha()
  }
}
</script>

<style>
.send-email {
  margin-top: 5px;
}
img.logo {
  display: block;
  width: min(260px, 72vw);
  max-width: 260px;
  height: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?7c4eae0b